<template>
  <div>
    <list
      row-key="LeaveId"
      ref="list"
      unit="学生纪律量化登记"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="$permission.canWrite()"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <el-button size="mini" type="success" plain @click="onExport" v-if="!isMB">导出</el-button>
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.GradeId" @change="getClass" clearable>
            <template v-for="(i,index) in grades">
              <el-option :key="index" :value="i.GradeId" :label="i.Grade"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="params.ClassId" clearable>
            <template v-for="(i,index) in classes">
              <el-option :key="index" :value="i.ClassId" :label="i.ClassName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="宿舍号">
          <el-input size="mini" v-model="params.Dormitory" placeholder="请填写宿舍号" clearable />
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input v-model="params.FullName" style="width:184px;" placeholder="请填写姓名"></el-input>
        </el-form-item>
        <el-form-item label="扣分原因" class="longForm">
          <el-select v-model="params.DisciplineTypeIdChains" multiple filterable clearable>
            <el-option v-for="item in disciplineList" :key="item.DisciplineTypeId" :label="item.DisciplineTypeName" :value="item.IdChain">
              <span v-if="item.Lv==2" class="l-icon">L</span>
              <span>{{item.DisciplineTypeName}}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登记方式">
          <el-select v-model="params.RecordWay" clearable size="mini">
            <el-option :value="0" label="系统"></el-option>
            <el-option :value="1" label="手动"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="扣分人">
          <el-input v-model="params.FullName" style="width:184px;" placeholder="请填写姓名"></el-input>
        </el-form-item> -->
        <el-form-item label="扣分时间">
          <el-date-picker
            v-model="params.StartDate"
            placeholder="请选择日期"
            style="width:184px;"
            clearable
            value-format="yyyy-MM-dd"
          />
          -
          <el-date-picker
            v-model="params.EndDate"
            placeholder="请选择日期"
            style="width:184px;"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="FullName" label="学生姓名" />
        <el-table-column prop="Grade" label="年级" />
        <el-table-column prop="Class" label="班级" />
        <el-table-column prop="Dormitory" label="宿舍号" />
        <el-table-column prop="DisciplineTypeName" label="扣分原因" />
        <el-table-column prop="Point" label="分值" />
        <el-table-column prop="RecordTime" label="扣分时间" min-width="140">
          <!-- <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.RecordTime)}}</span>
          </template> -->
        </el-table-column>
        <el-table-column prop="AddTeacherName" label="扣分人" />
        <el-table-column prop="RecordWay" label="登记方式">
          <template slot-scope="{row}">
            <span v-if="row.RecordWay==0">系统</span>
            <span v-else-if="row.RecordWay==1">手动</span>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注" min-width="130px" show-overflow-tooltip />
        <el-table-column prop="FileUrl" label="附件" width="80" align="center">
          <template slot-scope="{row}">
            <template v-if="row.FileUrl">
              <el-button type="text" v-if="isImg(row.FileUrl)" @click="viewImg(row.FileUrl)">查看</el-button>
              <el-button type="text" v-else @click="dl(row)">下载</el-button>
            </template>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <el-dialog title="查看图片" :visible.sync="dialogVisible" :append-to-body="true">
      <img width="100%" :src="dialogImageUrl" alt />
      <div slot="footer">
        <el-button @click="dialogVisible=false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  data() {
    return {
      api: require("@/api/attendance/disrecord").default,
      grade_api: require("@/api/ed/grade").default,
      class_api: require("@/api/ed/class").default,
      termApi: require("@/api/ed/term").default,
      disApi: require("@/api/attendance/disciplinetype").default,
      params: {
        TermId: null,
        GradeId: null,
        ClassId: null,
        RecordWay: null,
        Dormitory: "",
        FullName: "",
        StartDate: "",
        EndDate: "",
        DisciplineTypeIdChains: [],
      },
      dialogVisible: false,
      dialogImageUrl: "",
      disciplineList: [],
      termList: [],
      grades: [],
      classes: [],
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.params.TermId = loginInfo.TermId;
    this.termApi.list().then((res) => {
      if (res.Data && res.Data.length > 0) {
        this.termList = res.Data;
        this.$refs.list.initQueryParams.TermId = this.params.TermId;
        this.query({});
      }
    });
    localStorage.setItem("quaTerm",this.params.TermId);
    this.getGrade();
    this.disApi.list({ Status: 1 }).then(res => {
      if(res.Code == 0) {
        this.disciplineList = res.Data;
      }
    })
  },
  methods: {
    termChange(e) {
      this.params.ClassId = null;
      this.sectionList = [];
      this.getClass();
      this.getGrade();
      this.query({ TermId: e });
      localStorage.setItem("quaTerm",e);
    },
    getGrade() {
      this.grade_api.list().then((res) => {
        this.grades = res.Data;
      });
    },
    getClass() {
      this.params.ClassId = null;
      if (!this.params.GradeId) {
        this.classes = [];
        return;
      }
      var params = { GradeId: this.params.GradeId, TermId: this.params.TermId };
      this.class_api.list(params).then((res) => {
        this.classes = res.Data;
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    onExport() {
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
    viewImg(url) {
      this.dialogImageUrl = '/api' + url;
      this.dialogVisible = true;
    },
    dl(item) {
      // window.open('/api'+item.FileUrl);
      const elink = document.createElement("a");
      elink.download = item.FileName||item.FileUrl.split("/")[4];
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = location.origin + "/api" + item.FileUrl;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    isImg(url) {
      var ex = url.split(".")[1];
      return ex=='jpg'||ex=='png'||ex=='jpeg';
    }
  },
};
</script>
<style lang="scss" scoped>
.l-icon {
  margin: 0 2px 0 5px;
  vertical-align: 3px;
}
.longForm {
  width: 538px;
  /deep/ .el-input__inner {
    width: 100% !important;
  }
}
</style>